import { Text } from "@chakra-ui/react";
import { MouseEventHandler } from "react";
import { FormattedMessage } from "react-intl";

import { RanaTable } from "@nens/ranalib";

import { useIconSrc } from "@/hooks/use-icon-src";

type UserOrInviteProps = {
  onLinkCLick?: MouseEventHandler<HTMLElement>;
  isInvite?: boolean;
};

export function TableEmptyUserOrInvite({ onLinkCLick, isInvite = false }: UserOrInviteProps) {
  const icon = useIconSrc("user");
  return (
    <RanaTable.Empty icon={icon}>
      <Text>
        {!isInvite && (
          <FormattedMessage id="projectfiles.no_users_found" defaultMessage="No users found" />
        )}
      </Text>
      {onLinkCLick && (
        <Text cursor="pointer" textDecor="underline" color="brand.analytic" onClick={onLinkCLick}>
          <FormattedMessage id="users.invite_users" defaultMessage="Invite users" />
        </Text>
      )}
    </RanaTable.Empty>
  );
}
